import { useState } from 'react';
import { Button } from 'antd';
import { useTranslate } from '@tolgee/react';
import { ButtonProps } from 'antd/es/button';
import { CommonRefund } from 'services/api/return';
import ProposeDlg from './ProposeDlg';

interface IProps extends CommonRefund {
  unit: string;
  allowOffer: Conversation.Trade.IAllowOffer[];
  children?: React.ReactNode;
  operationLog: Conversation.Trade.IReturnOperationLog[];
  offerCounterLimit: number;
  displayStatus: Conversation.Trade.IDisplayStatus;
}

/**
 * 修改出价;
 * 本质上调用的接口是和提出部分退款一样的, 包括ui和逻辑。
 * 但是之后可能会有区分，这里第一层的button逻辑选择复制过来，而不是直接使用ProposeConsultButton
 */
const ModifyPrice = (props: Omit<ButtonProps, 'onClick'> & IProps & { onSuccess?: () => void }) => {
  const { t } = useTranslate();

  const {
    externalStoreId,
    returnSn,
    externalTradeId,
    onSuccess,
    unit,
    allowOffer,
    children,
    operationLog,
    offerCounterLimit,
    displayStatus,
    ...btnProps
  } = props;

  const [visible, setVisible] = useState(false);
  const title = t('trade.修改出价');

  return (
    <>
      <Button
        size="small"
        {...btnProps}
        onClick={() => {
          setVisible(true);
        }}
        disabled={offerCounterLimit === 0}
      >
        {title}({offerCounterLimit}/3)
      </Button>
      <ProposeDlg
        unit={unit}
        allowOffer={allowOffer}
        visible={visible}
        setVisible={setVisible}
        returnSn={returnSn}
        onSuccess={onSuccess}
        operationLog={operationLog}
        offerCounterLimit={offerCounterLimit}
        title={title}
      >
        {children}
      </ProposeDlg>
    </>
  );
};

export default ModifyPrice;
